import { render, staticRenderFns } from "./AMRGB65.vue?vue&type=template&id=c381df40&scoped=true"
import script from "./AMRGB65.vue?vue&type=script&lang=ts"
export * from "./AMRGB65.vue?vue&type=script&lang=ts"
import style0 from "./AMRGB65.vue?vue&type=style&index=0&id=c381df40&prod&lang=scss&scoped=true"
import style1 from "./AMRGB65.vue?vue&type=style&index=1&id=c381df40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c381df40",
  null
  
)

export default component.exports